"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagData = void 0;
class TagData {
    constructor(data) {
        this.text = 'Tag';
        this.tagColor = "#66627E";
        if (data) {
            data = (typeof data === "string") ? JSON.parse(data) : data;
            this.text = ('text' in data && data.text) ? data.text : 'Tag';
            this.tagColor = ('tagColor' in data && data.tagColor) ? data.tagColor : '#66627E';
        }
    }
}
exports.TagData = TagData;
//# sourceMappingURL=TagData.js.map